import React from "react";
import { InspectorServiceTravelRuleResponse } from "interfaces/Mueller.Business.Models";
import moment from "moment";
import IconButton from "components/Shared/IconButton";
import { classes } from "components/Utility";

interface Props {
  travelRule: InspectorServiceTravelRuleResponse,
  onEditClicked?: (travelRule: InspectorServiceTravelRuleResponse) => void,
  onCopyClicked?: (travelRule: InspectorServiceTravelRuleResponse) => void,
  onDeleteClicked?: (travelRule: InspectorServiceTravelRuleResponse) => void,
  onMouseEvent?: (event: "enter" | "leave") => void,
};

const recurStringMap = {
  sunday: "Su",
  monday: "M",
  tuesday: "T",
  wednesday: "W",
  thursday: "R",
  friday: "F",
  saturday: "S",
};

const dateToString = (date: Date, includeDow = false) => moment(date).format(`${includeDow ? "ddd " : ""}MMM D, YYYY`);

const TravelRuleCard = ({
  travelRule,
  onEditClicked,
  onCopyClicked,
  onDeleteClicked,
  onMouseEvent,
}: Props) => {

  // show day of week if theres no end date
  let ruleDate = dateToString(travelRule.startDate, !travelRule.endDate);

  if (travelRule.endDate) {
    ruleDate += ` - ${dateToString(travelRule.endDate)}`;
  }

  let recurString = Object.keys(recurStringMap).map(k => travelRule.recursOn?.[k] ? recurStringMap[k] : null).filter(s => s).join("/");
  if (recurString !== "") ruleDate += ` (${recurString})`;

  const tomorrow = moment().add(1, "day").startOf("day");

  let canEdit = true;
  if ((moment(travelRule.startDate).startOf("day").isBefore(tomorrow) && !travelRule.endDate) || moment(travelRule.endDate).startOf("day").isBefore(tomorrow)) {
    canEdit = false;
  }

  let repeatText: string = null;

  switch (travelRule.repeatEveryUnit) {
    case "every-x-week":
      if (travelRule.repeatAmount === 1) repeatText = "Repeats Weekly";
      if (travelRule.repeatAmount === 2) repeatText = "Repeats Every Other Week";
      break;
    case "every-x-day-in-month":
      repeatText = "Repeats Monthly";
      break;
  }

  return (
    <div className="travel-rule-card" onMouseEnter={() => onMouseEvent?.("enter")} onMouseLeave={() => onMouseEvent?.("leave")} >
      <div className="name-and-buttons">
        <div className="rule-name">
          <span>{travelRule.name}</span>
          {(travelRule.startingLocationType === "Travel") && <IconButton icon="airplanemode_active" />}
        </div>
        { // calling onMouseEvent with "leave" to reset the hover state of the card when clicking on the buttons
          <div className="rule-actions">
            <IconButton icon="content_copy" onClick={() => { onMouseEvent?.("leave"); onCopyClicked(travelRule); }} />
            {canEdit && (<>
              <IconButton icon="edit" onClick={() => { onMouseEvent?.("leave"); onEditClicked(travelRule); }} />
              <IconButton icon="delete" onClick={() => { onMouseEvent?.("leave"); onDeleteClicked(travelRule); }} />
            </>)}
          </div>
        }
      </div>
      <div className="rule-dates">{ruleDate}</div>
      {repeatText && <div className="rule-repeats">{repeatText}</div>}
    </div>
  );

};

export default TravelRuleCard;
